<template>
  <div class="monitors-page-empty">
   <p id="intro-tagline">😎 Welcome back, <strong>John</strong>!</p>

    <div class="stats">
      <ul>
        <li>
          <h2>32</h2>
          <label>monitors</label>
        </li>
        <li>
          <h2>1,321</h2>
          <label>checks</label>
        </li>
        <li>
          <h2>523</h2>
          <label>snapshots</label>
        </li>
        <li>
          <h2>823</h2>
          <label>notifications</label>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  name: 'monitor-page-empty',
}
</script>

<style lang="scss">
.monitors-page-empty {
    text-align: center;
    padding: 40px 0;

    #intro-tagline {
      font-size: 40px;
    }

  .stats {
    ul {
      display: grid;
      grid-template-columns: 1fr 1fr 1fr 1fr;
      grid-gap: 10px;

      li {
        list-style: none;
        text-align: center;

        border-radius: 2px;
        padding: 11px 19px;
        width: 100%;
        position: relative;

        h2 {
          font-size: 68px;
          font-weight: bold;
          margin: 0;
          color: #737786;
        }

        label {
          font-weight: 300;
          color: #cad3dc;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/MonitorPageEmpty.vue